import { submitScore, getLeaderboard } from '@/arise/api';
import { AriseBridgeHost } from '@/arise/bridge/AriseBridgeHost';
import { setIsLeaderboardOpen } from '@/state/features/app';
import { useAppDispatch } from '@/state/store';
import { useEffect } from 'react';

export default function useLeaderboardBridgeEvents(bridge: AriseBridgeHost | null) {
    const dispatch = useAppDispatch();

    function onShowLeaderboard(event: CustomEvent<boolean>) {
        dispatch(setIsLeaderboardOpen(event.detail));
    }

    async function onSubmitScore(data: { detail: { leaderboardId: string; score: number } }) {
        try {
            const result = await submitScore(data.detail.leaderboardId, data.detail.score);
            bridge!.sendEvent('submit-score-response', result);
        } catch (error) {
            console.log('Failed to submit score', error);
            bridge!.sendEvent('submit-score-response', { accepted: false, reason: 'error' });
        }
    }

    async function onGetLeaderboard(data: { detail: { leaderboardId: string } }) {
        try {
            const result = await getLeaderboard(data.detail.leaderboardId);
            bridge!.sendEvent('leaderboard-data', result);
        } catch (error) {
            console.log('Failed to get leaderboard', error);
        }
    }

    useEffect(() => {
        if (!bridge) return;

        bridge.on('show-leaderboard', onShowLeaderboard);
        bridge.on('submit-score', onSubmitScore);
        bridge.on('get-leaderboard', onGetLeaderboard);

        return () => {
            bridge.off('show-leaderboard', onShowLeaderboard);
            bridge.off('submit-score', onSubmitScore);
            bridge.off('get-leaderboard', onGetLeaderboard);
        };
    }, [bridge]);
}
